module.exports = __webpack_public_path__ + "static/wire-about-1-dc10ab458fe9eb9840a0e66b607dbf6a.png";